import URI from 'urijs';

import BaseView from 'source/lib/base_view';
import template from 'authentication/templates/wrapper.html';

const WrapperView = BaseView.extend({
    template,
    render() {
        const query = this.query || URI.parseQuery(window.location.search);
        const context = {
            popup: query.display === 'popup'
        };
        BaseView.prototype.render.call(this, context);
    }
});

export default WrapperView;



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/wrapper.js